export default "__VITE_ASSET__DRJ4jC2S__"